import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 200;
`;

export const ModalOverlay = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 501;
`;

export const ModalSubheading = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: ${p => p.theme.palette.trout};
  opacity: 0.6;
  position: absolute;
  top: 65px;
`;

export const ModalBox = styled.div`
  min-width: ${p => (p.width ? p.width : p.minWidth)};
  ${p => p.maxWidth && `max-width: ${p.maxWidth}px`};
  min-height: ${p => p.minHeigh};
  ${p => p.maxHeight && `max-height: ${p.maxHeight}`};
  background: ${p => p.theme.palette.white};
  box-shadow: 0px 2px 36px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 502;
  border-top: 3px solid #417dff;
`;

export const ModalCloseButton = styled.button`
  background: #fff;
  position: absolute;
  top: 22px;
  right: 22px;
  border: none;
  outline: none;
  cursor: pointer;
`;

export const ModalContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  height: ${p => (p.maxHeight ? p.maxHeight : 'auto')};
  margin-top: ${p => (p.isHeader ? '20px' : 0)}
  &::-webkit-scrollbar {
    width: 0px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;

export const ModalFooter = styled.div`
  margin: ${p => (p.isHeader ? 0 : '10px 0px 0px')};
`;

export const ModalTitle = styled.p`
  color: #404040;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  padding: ${p => (p.titlePadding ? p.titlePadding : ' 32px 0 0 32px')};
  margin: 0;
`;

export const ModalHeader = styled.div``;
